const DRAFT_KEY_PREFIX = 'zynacular_form_draft_';

export function getDraftKey(userId) {
  return `${DRAFT_KEY_PREFIX}${userId}`;
}

export function clearDraft(userId) {
  if (!userId) return;
  sessionStorage.removeItem(getDraftKey(userId));
}

// ── localStorage autosave draft ──
// Separate mechanism from the sessionStorage bridge above: different key
// prefix, different lifetime (survives a closed tab, subject to a TTL),
// and deliberately excludes resume content. See docs/ANALYSIS.md Phase 13.
const LOCAL_DRAFT_KEY_PREFIX = 'zynacular_draft_';
const LOCAL_DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export function getLocalDraftKey(userId) {
  return `${LOCAL_DRAFT_KEY_PREFIX}${userId}`;
}

// data: { jobDescription, applicationInfo, applicationSource, documents } — resume is never included.
export function writeLocalDraft(userId, data) {
  if (!userId) return;
  try {
    localStorage.setItem(getLocalDraftKey(userId), JSON.stringify({
      userId,
      savedAt: Date.now(),
      ...data,
    }));
  } catch (_) {
    // localStorage can throw (quota exceeded, private-browsing restrictions, etc.) — autosave is best-effort.
  }
}

// Returns the stored draft's data (without userId/savedAt) if it exists, belongs to this user,
// and hasn't expired — otherwise discards it (if present) and returns null. Never throws.
export function readLocalDraft(userId) {
  if (!userId) return null;
  const key = getLocalDraftKey(userId);
  const saved = localStorage.getItem(key);
  if (!saved) return null;
  try {
    const draft = JSON.parse(saved);
    const isExpired = !draft.savedAt || (Date.now() - draft.savedAt > LOCAL_DRAFT_TTL_MS);
    if (draft.userId !== userId || isExpired) {
      localStorage.removeItem(key);
      return null;
    }
    const { userId: _userId, savedAt: _savedAt, ...data } = draft;
    return data;
  } catch (_) {
    localStorage.removeItem(key);
    return null;
  }
}

export function clearLocalDraft(userId) {
  if (!userId) return;
  localStorage.removeItem(getLocalDraftKey(userId));
}
